import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient) { }

  
  public current(): Observable<any> {
    return this.httpClient.get('/api/media/current');
  }

  public recent(): Observable<any> {
    return this.httpClient.get('/api/media/users/recent');
  }

  public search(params: {}): Observable<any> {
    return this.httpClient.get('/api/media/users', { params: new HttpParams({ fromObject: params }) });
  }

  public get(userId: number): Observable<any> {
    return this.httpClient.get(`/api/media/users/${userId}`);
  }

  public save(userId: number, data: object): Observable<any> {
    return this.httpClient.post(`/api/media/users/${userId ? userId : ''}`, data);
  }

  public setPassword(userId: number, data: {}): Observable<any> {
    return this.httpClient.post(`/api/media/users/${userId}/password`, data);
  }
  
}
